// extracted by mini-css-extract-plugin
module.exports = {"title":"OfferPopup_title_1F76J","name":"OfferPopup_name_1hJ2A","info":"OfferPopup_info_1dVQH","price":"OfferPopup_price_96RIs"};